import React, { Component,lazy, Suspense  } from "react";
import { Route, Switch, Redirect } from "react-router-dom";
import axios from "axios";
import Step1 from "./Step1";
import moment from "moment"
import ThankYou from "./ThankYou";
import Decline from "./Decline";
import ProgressBar from '../ProgressBar/progressBar'
import CircularProgress from '@material-ui/core/CircularProgress';
var Step1a = lazy(() => import('./Step1a'));
const Step2 = lazy(() => import('./Step2'));
const Step3 = lazy(() => import('./Step3'));
const Step4 = lazy(() => import('./Step4'));
const Step5 = lazy(() => import('./Step5'));
const Step6 = lazy(() => import('./Step6'));
const Step7 = lazy(() => import('./Step7'));
const Step8 = lazy(() => import('./Step8'));
const Step9 = lazy(() => import('./Step9'));
const Step4a = lazy(() => import('./Step4a'));
const Step4b = lazy(() => import('./Step4b'));
const AddressValidation = lazy(() => import('./addressValidation'));
const Step11 = lazy(() => import('./Step11'));
const Step12 = lazy(() => import('./Step12'));
const Step13= lazy(() => import('./Step13'));
const Step14= lazy(() => import('./Step14'));
const Step15= lazy(() => import('./Step15'));

const defaultState = {
  // step1
  firstName: "",
  lastName: "",
  email: "",

  //step3
  company_name: "",

  //step2
  latLng: {},
  streetAddress: "",
  aptUnitNo: "",
  city: "",
  state: "",
  zipCode: "",

  // step4
  typeOfOrganization: "",

  // step8
  expensesFor12Months: "",

  // step5
  ssn: "",

  // step6
  phone: "",

  // step8
  businessFiledState: "",

  // step7
  ownershipOfBusinessDate:"",

  // step9
  descriptionOfbusiness: "",
  expectedNoOfEmployees:1,
  // step11
  cardDetails:{},
  paymentzipcode: "",
  paymentAddress:{},
  TransactionData: {},
  membersLLC:1,
  isLLCFiledInUs:true,
  isPayingEmploymentTax:"N",
  fiscalYearEnd:"December",
  Line10aCheckbox:"",
  Line10aStartedValue:"",
  Line10aOtherValue:"",
  Line10aBankingValue:"",
  Line10aChangedValue:"",
  Line10aCreatedTrustValue:"",
  Line10aCreatedPensionValue:"",
  streetAddress1:"",
  paymentAddressToDisplay:"",
  // step25
  manuel_address:false,
  agree: "",
  isLoader: false,
  //prime cloud
  isCloudStorageEnabled:Boolean,
  messagePrimeCloud:""
};
export default class MultiStepForm extends Component {
  state = defaultState;

  // componentDidMount = () => {
  //   const serializedState = localStorage.getItem("EINState");
  //   if (serializedState === null) {
  //     localStorage.setItem("EINState", JSON.stringify(this.state));
  //   } else {
  //     this.setState(JSON.parse(serializedState));
  //   }
  // };
  componentDidMount = () => {
    window.onbeforeunload = (event) => {
      const e = event || window.event;
      e.preventDefault();
      if (e) {
        e.returnValue = ''; 
      }
      return ''; 
    };
  };
  handleChangeField = (e, name, value) => {
    if(name === "lastName" || name ==="firstName"){
      var regex=/^[0-9]+$/;
      if(value.length){
        if (value[value.length-1].match(regex))
        {
            return
        }
      }
    
    }
    this.setState(
      {
        [name]: value,
      },
      () => {
        localStorage.setItem("EINState", JSON.stringify(this.state));
      }
    );
  };
  handleChangeState = (newState) => {
    this.setState(newState, () => {
      localStorage.setItem("ChangeAddressState", JSON.stringify(this.state));
    });
  };
  replaceFunction(value,symbol){
    if(!value){
      return ""
    }
    var returnValue = ""
    let splitedValue = value.split(symbol)
    if(splitedValue.length){
      for(var i=0;i<splitedValue.length;i++){
        returnValue += splitedValue[i]
        if(i===splitedValue.length-1){
          return returnValue
        }
      }
    }else{
      return value
    }
  }
  submitData() {
    const data = {
      firstname: this.state.firstName,
      lastname: this.state.lastName,
      address: `${this.state.streetAddress}, ${this.state.city}, ${this.state.state} ${this.state.zipCode}`,
      addressObject:{
        street:this.state.streetAddress,
        city:this.state.city,
        zipCode:this.state.zipCode,
        state:this.state.state

      },
      businessName: this.state.company_name,
      businesstype: this.state.typeOfOrganization,
      ssn: this.replaceFunction(this.state.ssn,"-"),
      phone: this.state.phone.replace(/[-)( ]/g, ""),
      ownershipOfBusinessDate: moment(this.state.ownershipOfBusinessDate).format("MM/DD/YYYY"),
      businessFilledState: this.state.businessFiledState,
      businessDescription: this.state.descriptionOfbusiness,
      cardNumber: this.state.cardDetails.creditCardNumber,
      expiry: this.state.cardDetails.exp,
      cvv: this.state.cardDetails.cvv,
      cardHolderName: this.state.cardDetails.nameOnCard,
      CustomerEmail: this.state.email,
      CustomerFirstName: this.state.firstName,
      CustomerLastName: this.state.lastName,
      transactionId:this.state.TransactionData && this.state.TransactionData.TransactionID,
      paymentAddress:this.state.paymentAddress,
      // 
      isLLCFiledInUs:this.state.isLLCFiledInUs,
      membersLLC:this.state.membersLLC,
      isPayingEmploymentTax:this.state.isPayingEmploymentTax ==="Y"?true:false,
      expectedNoOfEmployees:this.state.expectedNoOfEmployees,
      fiscalYearEnd:this.state.fiscalYearEnd,
      // 
      Line10aStartedValue:this.state.Line10aStartedValue,
      Line10aOtherValue:this.state.Line10aOtherValue,
      Line10aBankingValue:this.state.Line10aBankingValue,
      Line10aChangedValue:this.state.Line10aChangedValue,
      Line10aCreatedTrustValue:this.state.Line10aCreatedTrustValue,
      Line10aCreatedPensionValue:this.state.Line10aCreatedPensionValue,
      Line10aCheckbox:this.state.Line10aCheckbox

    };
    var config = {
      headers: {
        "Content-Type": "application/json",
        "Accept-Encoding": "gzip, deflate, br",
        "Access-Control-Allow-Origin": "*",
        Authorization:
          "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.IjVmODQ4YmUzZDU3NGNiZGU4NGY3MzdlZGQzMzhmYmJiYjc4NGNmMzQwNzEyMjRkNjUwNmEyZDA0MDk4ZmU5ZDJiNzJlZmU5ZmZlZGIwNWY4NDhiZTNkNTc1MTQ4ODA0ZTE5NWIyYTE2OTc1MWyzDhbWeejNw39fPnaz8jGwtzUwyvtXNTc3OSI.pNY0J4jQbh3rm9k2Ry52hYjHDSZkFpt6Chdincc8lVg",
      },
    };

    if (
      Object.keys(this.state.TransactionData).length > 0 &&
      !this.state.isLoader
    ) {
      this.setState({ isLoader: true });
      axios
        .post(
          // "https://migrationade.com/staging/api/ein",
          "ein.php",
         JSON.stringify(data), config)
        .then((response) => {
          this.setState(defaultState);
          this.setState({ isLoader: false });
          localStorage.removeItem("EINState");
        })
        .finally(() => {
          this.setState(defaultState);
        });
    }
  }

  renderStep = (props) => {
    const { history } = props;
    const { path, params } = props.match;
    if (params.step === "thankyou") {
      if(!this.state.isLoader)
            this.submitData();
      return <ThankYou isLoader={this.state.isLoader} />;
    } else if (params.step === "decline") {
      return <Decline />;
    }
    const step = parseInt(params.step);
    const currentPath = `/${path.split("/")[1]}`;
    const renderLoader = () => <div style={{display:"flex",justifyContent:"center"}}><CircularProgress/></div>;
    switch (step) {
      case 1:
        return (
         
          <Step1
            history={history}
            nextStep={`${currentPath}/2`}
            state={this.state}
            onChangeField={this.handleChangeField}
          />
        );
      case 2:
        return (
          <Suspense fallback={renderLoader()}>
          <Step1a
            history={history}
            prevStep={`${currentPath}/1`}
            nextStep={`${currentPath}/3`}
            state={this.state}
            onChangeField={this.handleChangeField}
            onChangeState={this.handleChangeState}
          />
          </Suspense>
        );
      case 3:
        return (
          <Suspense fallback={renderLoader()}>
          <Step2
            history={history}
            prevStep={`${currentPath}/2`}
            nextStep={`${currentPath}/4`}
            state={this.state}
            onChangeField={this.handleChangeField}
          />
          </Suspense>
        );
      case 4:
        return (
          <Suspense fallback={renderLoader()}>
          <Step3
            history={history}
            prevStep={`${currentPath}/3`}
            nextStep={`${currentPath}/5`}
            state={this.state}
            onChangeField={this.handleChangeField}
          />
          </Suspense>
        );
      case 5:
        return (
          <Suspense fallback={renderLoader()}>
          <Step4
            history={history}
            prevStep={`${currentPath}/4`}
            nextStep={`${currentPath}/8`}
            nextStepLlc={`${currentPath}/6`}
            state={this.state}
            onChangeField={this.handleChangeField}
          />
          </Suspense>
        );
      case 6:
        return (
          <Suspense fallback={renderLoader()}>
          <Step4a
            history={history}
            prevStep={`${currentPath}/5`}
            nextStep={`${currentPath}/7`}
            state={this.state}
            onChangeField={this.handleChangeField}
          />
          </Suspense>
        );
      case 7:
        return (
          <Suspense fallback={renderLoader()}>
          <Step4b
            history={history}
            prevStep={`${currentPath}/6`}
            nextStep={`${currentPath}/8`}
            state={this.state}
            onChangeField={this.handleChangeField}
          />
          </Suspense>
        );
      case 8:
        return (
          <Suspense fallback={renderLoader()}>
          <Step5
            history={history}
            prevStep={`${currentPath}/5`}
            prevStepLLC={`${currentPath}/7`}
            nextStep={`${currentPath}/9`}
            state={this.state}
            onChangeField={this.handleChangeField}
          />
          </Suspense>
        );
      case 9:
        return (
          <Suspense fallback={renderLoader()}>
          <Step6
            history={history}
            prevStep={`${currentPath}/8`}
            nextStep={`${currentPath}/10`}
            state={this.state}
            onChangeField={this.handleChangeField}
          />
          </Suspense>
        );
      case 10:
        return (
          <Suspense fallback={renderLoader()}>
          <Step7
            history={history}
            prevStep={`${currentPath}/9`}
            nextStep={`${currentPath}/11`}
            state={this.state}
            onChangeField={this.handleChangeField}
          />
          </Suspense>
        );
      case 11:
        return (
          <Suspense fallback={renderLoader()}>
          <Step8
            history={history}
            prevStep={`${currentPath}/10`}
            nextStep={`${currentPath}/12`}
            state={this.state}
            onChangeField={this.handleChangeField}
          />
          </Suspense>
        );
      case 12:
        return (
          <Suspense fallback={renderLoader()}>
          <Step12
            history={history}
            prevStep={`${currentPath}/11`}
            nextStep={`${currentPath}/13`}
            state={this.state}
            onChangeField={this.handleChangeField}
          />
          </Suspense>
        );
      case 13:
      return (
        <Suspense fallback={renderLoader()}>
        <Step13
          history={history}
          prevStep={`${currentPath}/12`}
          nextStep={`${currentPath}/14`}
          state={this.state}
          onChangeField={this.handleChangeField}
        />
        </Suspense>
      );
      case 14:
      return (
        <Suspense fallback={renderLoader()}>
        <Step14
          history={history}
          prevStep={`${currentPath}/13`}
          nextStep={`${currentPath}/15`}
          state={this.state}
          onChangeField={this.handleChangeField}
        />
        </Suspense>
      );
      case 15:
      return (
        <Suspense fallback={renderLoader()}>
        <Step15
          history={history}
          prevStep={`${currentPath}/14`}
          nextStep={`${currentPath}/16`}
          state={this.state}
          onChangeField={this.handleChangeField}
        />
        </Suspense>
      );
      case 16:
        return (
          <Suspense fallback={renderLoader()}>
          <Step9
            history={history}
            prevStep={`${currentPath}/15`}
            nextStep={`${currentPath}/17`}
            state={this.state}
            onChangeField={this.handleChangeField}
          />
          </Suspense>

        );
      case 17:
        return (
          <Suspense fallback={renderLoader()}>
          <Step11
            history={history}
            prevStep={`${currentPath}/16`}
            nextStep={`${currentPath}/thankyou`}
            state={this.state}
            onChangeField={this.handleChangeField}
            onChangeState={this.handleChangeState}
          />
          </Suspense>
        );
        case 161:
          return (
            <Suspense fallback={renderLoader()}>
            <AddressValidation
              history={history}
              prevStep={`${currentPath}/2`}
              nextStep={`${currentPath}/3`}
              state={this.state}
              onChangeField={this.handleChangeField}
              onChangeState={this.handleChangeState}
            />
            </Suspense>
          );
      default:
        return <div>invalid step</div>;
    }
  };
  render() {
    const { path } = this.props.match;
    return (
      <Switch>
        <Route
          path="/start"
          exact
          render={() => <Redirect to={`${path}/1`} />}
        />
       <Route
            path={`${path}/:step`}
            render={(props) => <><ProgressBar step={props.match.params.step}/>{this.renderStep(props)}</>}
          />
      </Switch>
    );
  }
}
